import { render, staticRenderFns } from "./province-cascader-widget.vue?vue&type=template&id=3904ecd6&scoped=true&"
import script from "./province-cascader-widget.vue?vue&type=script&lang=js&"
export * from "./province-cascader-widget.vue?vue&type=script&lang=js&"
import style0 from "./province-cascader-widget.vue?vue&type=style&index=0&id=3904ecd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904ecd6",
  null
  
)

export default component.exports